export default __webpack_public_path__ + "static/media/private.164d9125.jpg";